import { useAuth } from "../../hooks/useAuth";
import ErrorState from "../ui/ErrorState/ErrorState";
import Loader from "../ui/Loader/Loader";

interface AuthGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, fallback }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      fallback || (
        <ErrorState
          title="Authentication Required"
          description="Please authenticate to access this page"
          icon="Warning"
        />
      )
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
